import { takeEvery } from 'redux-saga/effects';

import * as messagesPageActions from 'store/modules/messagesPage';
import { openChatDialog } from './utils';

export default function* listenOpenChatDialog() {
  yield takeEvery(messagesPageActions.openChatDialog.toString(), openChatDialog);
}
